import { RootState } from 'editor/src/store/index';

const isTextPersonalizationPromotionBannerDismissed = (state: RootState) =>
  state.editorModules.sidebar.isTextPersonalizationPromotionBannerDismissed;

export default isTextPersonalizationPromotionBannerDismissed;
